export default __webpack_public_path__ + "static/media/cover-HHC.27097ec9.jpg";